import { FilterProvider } from "@/components/landing/FeeFilter";
import { APMOverview } from "@/pages/data/airport/APMOverview";
import { BaggageOverview } from "@/pages/data/airport/BaggageOverview";
import { CustomsPage } from "@/pages/data/airport/IntlFacilities";
import PaxOverviewPage from "@/pages/data/airport/PaxOverviewPage";
import TerminalOverviewPage from "@/pages/data/airport/TerminalOverviewPage";
import {
  ConcourseGatesPage,
  ConcoursePassengerFlowPage,
  ConcourseRestroomPage,
} from "@/pages/data/concourse/ConcoursePages";
import DataLayout from "@/pages/data/DataLayout";
import { DataPageProvider } from "@/pages/data/DataPageContext";
import {
  ConcoursePlaylistPage,
  TerminalPlaylistPage,
} from "@/pages/data/PlaysPage";
import { PassengerFlowPage } from "@/pages/data/terminal/TerminalDashboardPages";
import {
  TerminalCheckpointsPage,
  TerminalDoorPage,
  TerminalGatesPage,
  TerminalRestroomPage,
  TerminalTicketingPage,
} from "@/pages/data/terminal/TerminalInfoPages";
import { DateRangePage } from "@/pages/landing/DateRangePage";
import { DayViewPage } from "@/pages/landing/DayViewPage";
import { DateProvider } from "@/stores/DateContext";
import { Route, Routes } from "react-router-dom";

export default function DataRoutes() {
  return (
    <Routes>
      <Route
        path="/*"
        element={
          <DataPageProvider initialTitle="">
            <DateProvider>
              <FilterProvider>
                <DataLayout />
              </FilterProvider>
            </DateProvider>
          </DataPageProvider>
        }
      >
        <Route path={"airport/pax"} element={<PaxOverviewPage />} />
        <Route path={"airport/terminals"} element={<TerminalOverviewPage />} />
        <Route path={"airport/concerns"} element={<PaxOverviewPage />} />

        <Route path={"airport/intl"} element={<CustomsPage />} />
        <Route path={"airport/baggage"} element={<BaggageOverview />} />
        <Route path={"airport/apm"} element={<APMOverview />} />

        <Route
          path={"terminal/:terminal/gates"}
          element={<TerminalGatesPage />}
        />
        <Route
          path={"terminal/:terminal/checkpoints"}
          element={<TerminalCheckpointsPage />}
        />
        <Route
          path={"terminal/:terminal/ticketing"}
          element={<TerminalTicketingPage />}
        />
        <Route
          path={"terminal/:terminal/restrooms"}
          element={<TerminalRestroomPage />}
        />

        <Route
          path={"terminal/:terminal/doors"}
          element={<TerminalDoorPage />}
        />

        <Route
          path={"terminal/:terminal/density"}
          element={<PaxOverviewPage />}
        />
        <Route
          path={"terminal/:terminal/flow"}
          element={<PassengerFlowPage />}
        />
        <Route
          path={"terminal/:terminal/pain-points"}
          element={<TerminalPlaylistPage />}
        />

        <Route
          path={"concourse/:concourse/gates"}
          element={<ConcourseGatesPage />}
        />
        <Route
          path={"concourse/:concourse/restrooms"}
          element={<ConcourseRestroomPage />}
        />

        <Route
          path={"concourse/:concourse/flow"}
          element={<ConcoursePassengerFlowPage />}
        />

        <Route
          path={"concourse/:concourse/pain-points"}
          element={<ConcoursePlaylistPage />}
        />

        <Route path={"landing/day/:date"} element={<DayViewPage />} />
        <Route path={"landing/report"} element={<DateRangePage />} />
      </Route>
    </Routes>
  );
}
